import * as $ from 'jquery';
import { orderPaymentEdit } from '../../../../redux/actions/order/orderPaymentActions';
import Alert from '../../../../itrust_common/components/Alert';
import { orderUpdate } from '../../../../redux/actions/order/orderActions';
import { useDispatch } from 'react-redux';
import CurrencyTypeView from '../../../../itrust_common/components/others/CurrencyTypeView';

export default function FinalizeButton(props) {
  const { children, onFinalize, orderStaffId, balanceDue, patientName, orderId, showRequiredAuth } = props
  const dispatch = useDispatch()

  const handlePaymentEdit = () => {
    if (showRequiredAuth) {
      Alert.warning("Please enter 1500 Prior Authorization Number to Pay & Finalize this order.")
      return
    }
    if (orderStaffId) {
      if (balanceDue) {
        onFinalize()
        dispatch(orderPaymentEdit('New'))
        $("#orderFinalizeForm-modal").modal()
      }
      else {
        Alert.confirm(<div>The balance due is <strong><CurrencyTypeView amount={balanceDue} /></strong>. You're finalizing order for <strong>{patientName}</strong>.</div>,
          (res) => {
            if (res) {
              dispatch(orderUpdate({ id: orderId, status: 'finalized' }, { include: '*' }))
            }
          }
        )
      }
    }
    else {
      Alert.warning("Please select provider to finalize the order.")
    }
  }

  return (
    <span className="pointer" onClick={handlePaymentEdit}>
      {children}
    </span>
  )
}